import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Footer from './footer';
import Nav from '@ifeng-fe/container_channel/common/client/components/nav';
import styles from './index.css';
import Content from './content';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const {
            content: { footer, commonNav },
        } = this.props;

        return (
            <Fragment>
                <div className={styles.nav_box}>
                    <div className={styles.main_nav}>
                        <Chip id="20002" type="struct" title="全站导航" groupName="头部" content={commonNav}>
                            <Nav limit={18} />
                        </Chip>
                        <div className={styles.userinfo}>
                            <UserInfo />
                        </div>
                    </div>
                </div>
                <Content />
                <Footer content={footer} />
                <ChipEdit transform={transform} />
            </Fragment>
        );
    }
}

export default Layout;
